import { get } from 'utils/rxfetch'

// One GET builds every widget. Response is camelCase except the `counts` maps
// in alertsOverTime, whose keys are category ids. See ato_overview_rest.py.
const BASE = '/members-api/ato-overview'

// MSP scoping goes through companyFilter, like the other settings endpoints.
const buildQuery = ({ timeframe, from, to }, companyId) => {
  const params = new URLSearchParams({ timeframe })
  if (from) params.set('from', from)
  if (to) params.set('to', to)
  if (companyId) params.set('companyFilter', companyId)
  return `${BASE}?${params.toString()}`
}

export default () => ({
  // `from`/`to` are ISO dates, only used when timeframe is 'custom'.
  getOverview(query, companyId = '') {
    return get(buildQuery(query, companyId))
  },
})
